import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable, from } from "rxjs";
import { map, switchMap, find } from "rxjs/operators";
import { Catalogo } from "src/app/models/entities/catalogo";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CatalogoService {
  private path: string = "catalogos";

  public constructor(
    private angularFireDatabase: AngularFireDatabase,
    public http: HttpClient
  ) {}

  public obtenerListaDeCatalogos(): Observable<Catalogo[]> {
    return this.angularFireDatabase
      .list<Catalogo>(this.path)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as Catalogo)
          )
        )
      );
  }

  /**
   * Obtiene los elementos activos del catálogo.
   * @param ruta Viene de la lista de enumeradores en el modulo Shared
   */
  public obtenerCatalogo<T>(ruta: string): Observable<T[]> {
    return this.angularFireDatabase
      .list<T>(`catalogos/${ruta}/catalogo`)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as T)
          )
        ),
        map((catalogo: T[]) => catalogo.filter((c: T) => (c as any).activo))
      );
  }

  /**
   *Obtiene un elemento de un catalogo
   * @param ruta Viene de la lista de enumeradores en el modulo Shared
   * @param key Se encuentra en la administracion de catalogos del sistema
   */
  public obtenerElementoDeCatalogoPorKey<T>(
    ruta: string,
    key: string
  ): Observable<T> {
    return this.angularFireDatabase
      .object<T>(`catalogos/${ruta}/catalogo/${key}`)
      .snapshotChanges()
      .pipe(
        map(
          (c) =>
            ({
              key: c.payload.key,
              ...c.payload.val(),
            } as T)
        )
      );
  }

  public update(key: string, catalogo: Catalogo): Promise<any> {
    return this.angularFireDatabase
      .list<Catalogo>(this.path)
      .update(key, catalogo);
  }

  public save(
    catalogo: string,
    key: string,
    elemento: ElementoCatalogo
  ): Promise<any> {
    return this.angularFireDatabase
      .object<ElementoCatalogo>(`${this.path}/${catalogo}/catalogo/${key}`)
      .set(elemento);
  }

  public updateElemento(
    keyCatalogo: string,
    keyElemento: string,
    elemento: ElementoCatalogo
  ): Promise<any> {
    return this.angularFireDatabase
      .list<ElementoCatalogo>(`${this.path}/${keyCatalogo}/catalogo`)
      .update(keyElemento, elemento);
  }

  public saveCatalogo(catalogo: Catalogo): Promise<any> {
    let { key } = catalogo;
    delete catalogo.key;
    return this.angularFireDatabase
      .object<Catalogo>(`${this.path}/${key}`)
      .set(catalogo);
  }
}
